import { Button, Col, Form, Input, Modal, Row, Select, Switch } from "antd";
import { DatePicker } from "components/index";
import moment from "moment";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function ModalCreatedShop({
  form,
  openModal,
  onCancel,
  selected,
  handleSubmit,
  loading,
  glOptions = [],
}) {
  const { t } = useTranslation()

  useEffect(() => {
    if (selected) {
      form.setFieldsValue({
        code: selected.code,
        name: selected.name,
        address: selected.address,
        gl: selected.gl,
        openedAt: selected.openedAt ? moment(selected.openedAt, 'MM/YYYY') : null,
      });
    }
  }, [selected, form]);

  return (
    <Modal
      title={!selected ? t('addShop') : t('updateShop')}
      centered
      open={openModal}
      footer={null}
      onCancel={onCancel}
      width={768}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          name="code"
          label={t('shopCode')}
          required
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="name"
          label={t('shopName')}
          required
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="address"
          label={t('address')}
          required
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="gl"
          label={t('departmentManager')}
          required
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {glOptions.map(gl => (
              <Select.Option key={gl} value={gl}>
                {gl}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="openedAt"
          label={t('timeOpened')}
        >
          <DatePicker placeholder='' picker="month" format="MM/YYYY" />
        </Form.Item>
        <Row gutter={16}>
          <Col span={4} offset={8}>
            <Form.Item>
              <Button style={{ width: "100%" }} htmlType="submit" loading={loading}>
                Ok
              </Button>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Button style={{ width: "100%" }} onClick={onCancel} loading={loading}>
              {t('cancel')}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal >
  );
}